import { getWindow } from "../getWindow"

export const getZoomLevel = () => {
  const ssrWindow = getWindow()

  const devicePixelRatio = ssrWindow?.devicePixelRatio
  const innerWidth = ssrWindow?.innerWidth
  const screenWidth = ssrWindow?.screen?.width

  // Calculate the screen width ratio only if both values are defined
  const screenWidthRatio =
    innerWidth && screenWidth ? innerWidth / screenWidth : undefined

  // Use the device pixel ratio if available, otherwise fallback to the screen width ratio
  const zoomLevel =
    devicePixelRatio !== undefined ? devicePixelRatio : screenWidthRatio

  return zoomLevel
}
